const timer = setInterval(() => {
  const targetItems = document.querySelectorAll('.cd-rewards-free-gift-item-free'); 
  if (targetItems.length > 0) {
    let allUpdated = true;
    Array.from(targetItems).forEach((item) => {
      if (item.innerText !== 'Regalo') {
        item.innerText = 'Regalo'; 
        allUpdated = false; 
      }
    });
  }
}, 800);


function replaceButtonContent() {
    const buttons = document.querySelectorAll('.cd-rewards-free-gift .cd-rewards-free-gift-item-add.cd-main-button');

    buttons.forEach(button => {
        if (!button.querySelector('p') || button.textContent.trim() !== "Añadir Regalo") {
            button.innerHTML = '';
            const p = document.createElement('p');
            p.textContent = 'Añadir Regalo';
            button.appendChild(p);
        }
    });
}

setInterval(replaceButtonContent, 100);
